import { Typography, getTheme, styled } from '~/modules';

const textMain = getTheme('text.main');

export const Wrapper = styled(Typography)`
  color: ${textMain};
  font-weight: normal;
  font-family: 'Poppins', sans-serif;
`;
